import { ImageSharingRestService, newGenericRestRequest } from './restServices';
import storageService from '../storageService';
import VIDABOO_CONSTANTS from '../../config/consts';
import httpService from './httpService';
const service = {};

service.saveImageMessageByChatRoomId = async (
  senderObjectType,
  senderObjectId,
  chatRoomId,
  imageMsgBase64,
  cancelTokenCallback,
  progress,
) => {
  let currentTime = new Date();
  let mediaMessageDto = {};
  mediaMessageDto.senderObjectType = senderObjectType;
  mediaMessageDto.senderObjectId = senderObjectId;
  mediaMessageDto.chatRoomId = chatRoomId;
  mediaMessageDto.senderCreationTime = currentTime.getTime();
  mediaMessageDto.mediaType = VIDABOO_CONSTANTS.MEDIA_MESSAGE_TYPES.IMAGE;
  mediaMessageDto.imageMsgBase64 = imageMsgBase64;

  try {
    const cancelTokenSource = httpService.cancelToken.source();
    cancelTokenCallback(cancelTokenSource);
    const response = await newGenericRestRequest(
      'save',
      `${VIDABOO_CONSTANTS.REST_PATHS.IMAGE_MESSAGES}mediaMessage/roomId/${chatRoomId}`,
      { mediaMessageDto, token: storageService.getItem('token') },
      {
        onUploadProgress: (progressEvent) => {
          progress(
            ((progressEvent.loaded / progressEvent.total) * 100).toFixed(2),
          );
          console.debug(progressEvent);
        },
        cancelToken: cancelTokenSource.token,
      },
    );
    if (response.status === 200) {
      //   sendAudioMessageNotification(response.data.mmDto.mediaMessageId);
      console.debug(response, 'Response image sharing');
      return response;
    } else {
      return false;
    }
  } catch (error) {
    console.debug(error, 'error');
  }
};
service.uploadFileToS3 = async (
  base64,
  tempAccessUrl,
  progress,
  cancelTokenCallback,
) => {
  try {
    const cancelTokenSource = httpService.cancelToken.source();
    cancelTokenCallback(cancelTokenSource);
    const response = await newGenericRestRequest(
      'put',
      VIDABOO_CONSTANTS.MEDIA_MESSAGES_STORAGE + tempAccessUrl,
      base64,
      {
        onUploadProgress: (progressEvent) =>
          progress(
            ((progressEvent.loaded / progressEvent.total) * 100).toFixed(2),
          ),
        cancelToken: cancelTokenSource.token,
      },
    );
    if (response.status === 200) {
      return true;
    }
    return false;
  } catch (error) {
    console.debug(error, 'Error in uploading file');
  }
};

service.getImageByMsgId = async (fileMsgId) => {
  try {
    const response = await ImageSharingRestService.get(
      {
        endpoint: 'mediaMessageId',
        endpointParam: fileMsgId,
        endpoint2: 'userId',
        endpointParam2: storageService.getItem('guestUid'),

      },
      { token: storageService.getItem('token') },
    );
    return response;
  } catch (error) {
    console.debug(error);
  }
};

const imageSharingService = { ...service };
export default imageSharingService;
